var _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 65,
    viewBox: "0 0 59 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_50_373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.36875 35.4229C0.36875 19.378 13.4526 6.36875 29.5 6.36875C45.5474 6.36875 58.6312 19.378 58.6312 35.4229C58.6312 51.4677 45.5474 64.477 29.5 64.477C13.4526 64.477 0.36875 51.4677 0.36875 35.4229Z",
    stroke: "url(#paint0_radial_50_373)",
    strokeWidth: 0.7375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.36875 35.4229C0.36875 19.378 13.4526 6.36875 29.5 6.36875C45.5474 6.36875 58.6312 19.378 58.6312 35.4229C58.6312 51.4677 45.5474 64.477 29.5 64.477C13.4526 64.477 0.36875 51.4677 0.36875 35.4229Z",
    stroke: "url(#paint1_radial_50_373)",
    strokeWidth: 0.7375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.36875 35.4229C0.36875 19.378 13.4526 6.36875 29.5 6.36875C45.5474 6.36875 58.6312 19.378 58.6312 35.4229C58.6312 51.4677 45.5474 64.477 29.5 64.477C13.4526 64.477 0.36875 51.4677 0.36875 35.4229Z",
    stroke: "url(#paint2_radial_50_373)",
    strokeWidth: 0.7375
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_50_373)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.311,
    cy: 21.8431,
    rx: 18.7212,
    ry: 12.0709,
    fill: "url(#paint3_radial_50_373)",
    fillOpacity: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0888 23.2629C36.0865 23.2629 37.7874 24.5402 38.4176 26.3222H24.911C22.8826 26.3222 20.9373 27.128 19.503 28.5623C18.0687 29.9966 17.2629 31.9419 17.2629 33.9703V41.3585C16.3679 41.0418 15.5932 40.4555 15.0453 39.6802C14.4974 38.905 14.2033 37.9789 14.2036 37.0296V27.8518C14.2036 26.6348 14.6871 25.4676 15.5477 24.607C16.4083 23.7464 17.5755 23.2629 18.7925 23.2629H34.0888ZM40.2073 29.3815H24.911C23.694 29.3815 22.5268 29.8649 21.6662 30.7255C20.8056 31.5861 20.3221 32.7533 20.3221 33.9703V43.1481C20.3221 44.3652 20.8056 45.5324 21.6662 46.393C22.5268 47.2535 23.694 47.737 24.911 47.737H40.2073C41.4244 47.737 42.5916 47.2535 43.4521 46.393C44.3127 45.5324 44.7962 44.3652 44.7962 43.1481V33.9703C44.7962 32.7533 44.3127 31.5861 43.4521 30.7255C42.5916 29.8649 41.4244 29.3815 40.2073 29.3815ZM35.6184 38.5592C35.6184 39.3706 35.2961 40.1487 34.7224 40.7225C34.1487 41.2962 33.3705 41.6185 32.5592 41.6185C31.7478 41.6185 30.9697 41.2962 30.3959 40.7225C29.8222 40.1487 29.4999 39.3706 29.4999 38.5592C29.4999 37.7479 29.8222 36.9697 30.3959 36.396C30.9697 35.8223 31.7478 35.5 32.5592 35.5C33.3705 35.5 34.1487 35.8223 34.7224 36.396C35.2961 36.9697 35.6184 37.7479 35.6184 38.5592Z",
    fill: "#1CCBB1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_50_373",
    x: -3.6875,
    y: 2.3125,
    width: 66.375,
    height: 66.2207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.84375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_50_373"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_50_373",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_50_373",
    x: 1.03587,
    y: 0.218247,
    width: 56.5503,
    height: 43.2498,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.77698,
    result: "effect1_foregroundBlur_50_373"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_50_373",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-31.4149 12.0201) rotate(35.0407) scale(67.9615 40.1113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_50_373",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.273 45.3831) rotate(161.385) scale(49.2966 33.3191)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8470FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#865CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_50_373",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.1424 -7.449) rotate(47.2149) scale(32.9242 23.6648)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_50_373",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.311 9.77222) rotate(90) scale(17.8893 27.7484)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForex);
export default __webpack_public_path__ + "static/media/forex.6f793b72393557c91c75200156b4e3cf.svg";
export { ForwardRef as ReactComponent };